import axios from 'axios'
import { i18n } from '@/main.js' 

export default({
    state: {
        subject: null,
        subjects: [],

        createSubjectDialog: false,
    },

    getters: {
        getSubject(state){ return state.subject },
        getSubjects(state){ return state.subjects },

        getCreateSubjectDialog(state){ return state.createSubjectDialog },
    },

    mutations: {
        setSubject(state, value){ state.subject = value },
        setSubjects(state, value){ state.subjects = value },

        setCreateSubjectDialog(state, value){ state.createSubjectDialog = value },


        newSubject(state){
            state.subject = {
                name: "",
                code: "",
                titleId: null
            }
        },
    },

    actions: {
        getSubjects({ commit }){
            commit('setLoading')
            return new Promise((resolve) => {
                axios.get('/subjects')
                .then((response) =>{
                    commit('setSubjects', response.data)
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        createSubject({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.post('/subjects', state.subject)
                .then((response) => {
                    commit('setCreateSubjectDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('subjectCreated'), color: 'green'})
                    dispatch('getSubjects')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
